module.exports = __webpack_public_path__ + "src/assets/img/engine_five_color.666c5d68.svg";